export const extractTextFromHTML = (htmlString) => {
    // Create a temporary DOM element
    const tempElement = document.createElement('div');
    
    // Set the innerHTML of the temporary element
    tempElement.innerHTML = htmlString;
    
    // Use textContent to extract plain text
    const plainText = tempElement.textContent || tempElement.innerText;
    
    // Return the plain text
    return plainText;
  }